import Loadable from 'react-loading-overlay';
import { connect } from 'react-redux';

const mapStateToProps = state => ({
  spinner: true,
  active: state.loginForm.isFetching || false,
});

export default connect(mapStateToProps)(Loadable);